import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const EXTERNAL_TICKET_URL = `${API_HOST}/api/externalTicket`;

function* fetchExternalTicketServiceCodes() {
  yield takeEvery(actions.FETCH_EXTERNAL_TICKET_SERVICE_CODES, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${EXTERNAL_TICKET_URL}/services`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FETCH_EXTERNAL_TICKET_SERVICE_CODES_ENDED });
    }
  });
}

function* fetchExternalTicketLists() {
  yield takeEvery(actions.FETCH_EXTERNAL_TICKET_LISTS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${EXTERNAL_TICKET_URL}/services`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FETCH_EXTERNAL_TICKET_LISTS_ENDED });
    }
  });
}

function* createExternalTicket() {
  yield takeEvery(actions.CREATE_EXTERNAL_TICKET, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], EXTERNAL_TICKET_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_EXTERNAL_TICKET_ENDED });
    }
  });
}

function* searchExternalTickets() {
  yield takeEvery(actions.SEARCH_EXTERNAL_TICKETS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${EXTERNAL_TICKET_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EXTERNAL_TICKETS_ENDED });
    }
  });
}

function* searchExternalTicketIssuedRecords() {
  yield takeEvery(actions.SEARCH_EXTERNAL_TICKET_ISSUED_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EXTERNAL_TICKET_URL}/issuedRecord?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EXTERNAL_TICKET_ISSUED_RECORDS_ENDED });
    }
  });
}

function* updateExternalTicket() {
  yield takeEvery(actions.UPDATE_EXTERNAL_TICKET, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], EXTERNAL_TICKET_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_EXTERNAL_TICKET_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createExternalTicket),
    fork(searchExternalTickets),
    fork(updateExternalTicket),
    fork(fetchExternalTicketServiceCodes),
    fork(fetchExternalTicketLists),
    fork(searchExternalTicketIssuedRecords),
  ]);
}
